// Centralized brand + business configuration for Legacy Spa, LLC.
// All contact details, address, social links, disclosures and the Vagaro
// booking link live here so the site can be updated without redesigning it.

export const BRAND = {
  name: "Legacy Spa",
  legalName: "Legacy Spa, LLC",
  motto: "Where Wellness Meets Legacy.",
  parentCompany: "Legacy Forge Collective, LLC",
  endorsement: "A Legacy Forge Collective Company",
  logo: "/legacy-spa-logo.png",
  positioning: ["Houston-based", "Black-owned", "Veteran-owned"],
};

// Official production website.
export const OFFICIAL_SITE = "https://www.thelegacyspa.com";

// Single source of truth for external Vagaro booking. The in-app booking page
// lives at /book (BOOK_ROUTE) and embeds the Vagaro widget with this fallback.
export const BOOKING_URL = "https://www.vagaro.com/legacyspa1";
export const BOOK_ROUTE = "/book";

export const ADDRESS = {
  line1: "363 N Sam Houston Pkwy E",
  line2: "Suite 1440K",
  city: "Houston",
  state: "TX",
  zip: "77060",
  full: "363 N Sam Houston Pkwy E, Suite 1440K, Houston, TX 77060",
  mapsDirections:
    "https://www.google.com/maps/dir/?api=1&destination=363+N+Sam+Houston+Pkwy+E+Suite+1440K+Houston+TX+77060",
  mapsEmbed:
    "https://www.google.com/maps?q=363+N+Sam+Houston+Pkwy+E+Suite+1440K+Houston+TX+77060&output=embed",
};

export const ARRIVAL_NOTE =
  "Guests must sign in with building security downstairs upon arrival.";

export const CONTACT = {
  phone: "(832) 243-8853",
  phoneHref: "tel:+18322438853",
  email: "info@thelegacyspa.com",
  emailHref: "mailto:info@thelegacyspa.com",
  phonePlaceholder: "Phone coming soon",
  emailPlaceholder: "Email coming soon",
  hoursPlaceholder: "Hours coming soon",
};

export const HOURS = [
  { day: "Sunday", time: "By Request Only" },
  { day: "Monday", time: "8:00 AM – 12:00 PM" },
  { day: "Tuesday", time: "8:00 AM – 10:00 PM" },
  { day: "Wednesday", time: "8:00 AM – 12:00 PM" },
  { day: "Thursday", time: "8:00 AM – 12:30 PM" },
  { day: "Friday", time: "8:00 AM – 10:00 PM" },
  { day: "Saturday", time: "2:00 PM – 10:00 PM" },
];

export const SOCIAL = {
  instagram: {
    handle: "@legacyspawellness",
    url: "https://www.instagram.com/legacyspawellness/",
  },
};

export const SERVICE_AREA = "Greater Houston";

// Shared disclosure / disclaimer copy used across the prototype.
export const DISCLOSURES = {
  booking:
    "Service details, availability and pricing will be confirmed through Vagaro.",
  bookingComingSoon: "Online booking link coming soon",
  formSuccess:
    "Thank you. Your information has been sent to Legacy Spa. A member of our team will follow up using your preferred contact method.",
  formError:
    "We couldn’t send your request. Please try again or contact Legacy Spa directly at info@thelegacyspa.com or (832) 243-8853.",
  formRateLimit:
    "You’ve submitted a few times already. Please try again in a few minutes.",
  medicalFuture:
    "Medical-massage services are planned for a future phase. Availability, credentialing and eligibility information will be published once confirmed.",
  founderComingSoon:
    "Full professional profile and approved photograph coming soon.",
  therapistInterest:
    "Legacy Spa welcomes interest from qualified massage professionals as the company grows. Current opportunities will be posted when available.",
};

export const FOUNDER = {
  name: "Donald Lee, Sr.",
  title: "Founder & Massage Therapist",
  photo: "/donald-lee.webp",
  photoAlt: "Donald Lee, owner and licensed massage therapist at Legacy Spa.",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Mobile Massage", to: "/mobile-massage" },
  { label: "Corporate Wellness", to: "/corporate-wellness" },
  { label: "About", to: "/about" },
  { label: "Partnerships", to: "/partnerships" },
  { label: "Join Our Team", to: "/join-our-team" },
  { label: "Contact", to: "/contact" },
];

export const LEGAL_LINKS = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms & Conditions", to: "/terms-and-conditions" },
  { label: "Accessibility Statement", to: "/accessibility" },
];

// Versioned SMS marketing-consent disclosure language (for consent records).
export const SMS_CONSENT_VERSION = "2026-09-01";
export const SMS_CONSENT_TEXT =
  "I agree to receive marketing and promotional text messages from Legacy Spa at the phone number provided. Message frequency may vary. Message and data rates may apply. Consent is not a condition of purchase. Reply STOP to opt out and HELP for help.";

export const IMAGES = {
  heroBack:
    "https://images.pexels.com/photos/19641818/pexels-photo-19641818.jpeg?auto=compress&cs=tinysrgb&w=1600",
  massageRoom:
    "https://images.pexels.com/photos/6560308/pexels-photo-6560308.jpeg?auto=compress&cs=tinysrgb&w=1200",
  therapistHands:
    "https://images.pexels.com/photos/6187422/pexels-photo-6187422.jpeg?auto=compress&cs=tinysrgb&w=1200",
  corporateChair:
    "https://images.pexels.com/photos/4085451/pexels-photo-4085451.jpeg?auto=compress&cs=tinysrgb&w=1200",
  office:
    "https://images.pexels.com/photos/7653461/pexels-photo-7653461.jpeg?auto=compress&cs=tinysrgb&w=1400",
  shoulder:
    "https://images.pexels.com/photos/275768/pexels-photo-275768.jpeg?auto=compress&cs=tinysrgb&w=1200",
  inSuite:
    "https://images.unsplash.com/photo-1709755491926-f7aa83748967?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
};
